"use client";

import { useRef } from "react";
import { cn } from "@/lib/utils";
import CodeCopy from "./code-copy";

interface BlogContentProps {
  html: string;
  className?: string;
}

export default function BlogContent({ html, className }: BlogContentProps) {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className={cn("", className)}>
      <div
        ref={contentRef}
        className="article-body"
        dangerouslySetInnerHTML={{ __html: html }}
      />

      <CodeCopy containerRef={contentRef} />
    </div>
  );
}
